import { Avatar, Icon } from '@chakra-ui/react'
import { memo, useEffect, useState } from 'react'
import { ImageX } from '../../../utils/constants/icons'

const LazyLoadAvatarInner = ({
  src,
  w,
  h,
  isImage,
  onClick,
  name,
}: {
  src: string | undefined | null
  w?: number
  h?: number
  isImage?: boolean
  name?: string
  onClick?: () => void
}) => {
  // Fall back to initials when the logo is missing or fails to load, instead of
  // the browser's broken-image glyph.
  const [errored, setErrored] = useState(false)
  useEffect(() => {
    setErrored(false)
  }, [src])

  if (src === '' || !src || errored)
    return (
      <Avatar
        w={w ? `${w}px` : '20px'}
        h={h ? `${h}px` : '20px'}
        cursor={onClick ? 'pointer' : 'default'}
        onClick={onClick ? onClick : () => {}}
        name={name}
        size="sm"
        overflow="hidden"
        bg={name ? 'primary.50' : 'neutral.50'}
        color={name ? 'primary.500' : 'neutral.500'}
        icon={
          isImage && !name ? (
            <Icon
              w={w ? `${Math.min(w - 8, 40)}px` : '12px'}
              h={h ? `${Math.min(h / 2, 40)}px` : '12px'}
              color="neutral.500"
              fill="none"
            >
              <ImageX />
            </Icon>
          ) : undefined
        }
      />
    )

  return (
    <img
      loading="lazy"
      decoding="async"
      onClick={onClick}
      onError={() => setErrored(true)}
      src={src}
      alt={name ?? ''}
      style={{
        borderRadius: '50%',
        objectFit: 'cover',
        cursor: onClick ? 'pointer' : 'default',
        width: w ? `${w}px` : '20px',
        height: h ? `${h}px` : '20px',
        minHeight: h ? `${h}px` : '20px',
        maxHeight: h ? `${h}px` : '20px',
        minWidth: w ? `${w}px` : '20px',
        maxWidth: w ? `${w}px` : '20px',
        display: 'block',
      }}
    />
  )
}

const LazyLoadAvatar = memo(LazyLoadAvatarInner, (prev, next) => {
  return (
    prev.src === next.src &&
    prev.w === next.w &&
    prev.h === next.h &&
    prev.isImage === next.isImage &&
    prev.name === next.name
  )
})

export default LazyLoadAvatar
